import React, { useEffect, useState } from 'react';
import { Card, Spinner, ErrBox } from '../../../components/UI';
import { inventoryAPI } from '../../../utils/api';
import { fmtRp, fmtDate } from '../../../utils/format';

export default function DashboardTab() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { loadDashboard(); }, []);

  const loadDashboard = async () => {
    try {
      setLoading(true);
      const data = await inventoryAPI.getDashboard();
      setDashboard(data.data || data);
      setError(null);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  if (loading) return <div style={{ padding: '2rem', textAlign: 'center', color: '#6B7280' }}>Memuat...</div>;
  if (error) return <div style={{ padding: '1rem', background: '#FEF2F2', color: '#DC2626', borderRadius: 8 }}><ErrBox msg={error} onRetry={loadDashboard} /></div>;
  if (!dashboard) return <div style={{ padding: '2rem', textAlign: 'center' }}>Tidak ada data</div>;

  const s = dashboard;

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <Card style={{ borderLeft: '4px solid #2563EB', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Total Items</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1E40AF' }}>{s.total_items || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>barang tercatat</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #059669', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Total Gudang</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#047857' }}>{s.total_warehouses || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>lokasi aktif</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #EF4444', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Alert Stok</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#DC2626' }}>{s.alert_count || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>di bawah min</p>
        </Card>
        <Card style={{ borderLeft: '4px solid #F59E0B', padding: '14px 18px' }}>
          <p style={{ margin: '0 0 4px', fontSize: 11, fontWeight: 600, color: '#6B7280', textTransform: 'uppercase' }}>Low Stock</p>
          <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#D97706' }}>{s.low_stock_count || 0}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: '#9CA3AF' }}>perlu restok</p>
        </Card>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 20 }}>
        <Card>
          <h3 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 700, color: '#111827' }}>Ringkasan per Gudang</h3>
          {(s.summary_by_warehouse || []).length === 0 ? (
            <div style={{ padding: 20, textAlign: 'center', color: '#9CA3AF' }}>Tidak ada data</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Gudang</th>
                  <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Items</th>
                  <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Total Qty</th>
                </tr>
              </thead>
              <tbody>
                {(s.summary_by_warehouse || []).map((row, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid #F3F4F6' }}>
                    <td style={{ padding: '10px 12px', color: '#374151' }}>{row.warehouse}</td>
                    <td style={{ padding: '10px 12px', textAlign: 'right', color: '#374151' }}>{row.total_items}</td>
                    <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600, fontFamily: 'monospace', color: '#1E40AF', fontSize: 12 }}>{Number(row.total_quantity).toLocaleString('id-ID')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>
      </div>

      {(s.recent_movements || []).length > 0 && (
        <Card style={{ marginTop: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 700, color: '#111827' }}>Mutasi Terbaru</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#F9FAFB' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Tanggal</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Barang</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Tipe</th>
                <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Qty</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6B7280', borderBottom: '2px solid #E5E7EB', fontSize: 11 }}>Gudang</th>
              </tr>
            </thead>
            <tbody>
              {s.recent_movements.map((m, idx) => {
                const typeColor = { in: '#059669', out: '#DC2626', transfer: '#2563EB', adjustment: '#7C3AED' };
                return (
                  <tr key={idx} style={{ borderBottom: '1px solid #F3F4F6' }}>
                    <td style={{ padding: '10px 12px', color: '#6B7280', fontSize: 12 }}>{fmtDate(m.date)}</td>
                    <td style={{ padding: '10px 12px', color: '#374151' }}>{m.item_name}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: m.type === 'in' ? '#ECFDF5' : m.type === 'out' ? '#FEE2E2' : '#DBEAFE', color: typeColor[m.type] || '#374151' }}>
                        {m.type?.toUpperCase()}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>{m.quantity}</td>
                    <td style={{ padding: '10px 12px', color: '#374151' }}>{m.warehouse || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}